import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './sanolivar-style.css';

import Name from './utils/Name.js';

// import components
import Header from './components/Header.jsx';
import BannerIA from './components/BannerIA.jsx';
import Slider from './components/Slider.jsx';
import Form from './components/Form.jsx';
import Footer from './components/Footer.jsx';
import { assets, root } from './utils/Path.js';
import Chatbot from './components/Chatbot.jsx';

const assetsLocation = './assets/images/location/';

const sliderContent = [
  {
    name: 'Casos de uso Location Services',
    url: `${assets}images/casos-ls/snlr-main.webp`,
  },
  {
    name: 'Caso de uso - Retail',
    url: `${assets}images/casos-ls/snlr-retail.webp`,
  },
  {
    name: 'Caso de uso - Eventos',
    url: `${assets}images/casos-ls/snlr-eventos.webp`,
  },
  {
    name: 'Caso de uso - Educación',
    url: `${assets}images/casos-ls/snlr-educacion.webp`,
  },
  {
    name: 'Caso de uso - Salud',
    url: `${assets}images/casos-ls/snlr-salud.webp`,
  },
  {
    name: 'Caso de uso - Turismo',
    url: `${assets}images/casos-ls/snlr-turismo.webp`,
  },
  {
    name: 'Caso de uso - Hotelería',
    url: `${assets}images/casos-ls/snlr-hoteleria.webp`,
  }
];


createRoot(document.getElementById('location')).render(
  <StrictMode>
    <Header active={"Innovación & Servicios"} />
    {/* BANNER */}
    <section className="banner endark">
      <div className="background">
        <video loading="lazy" autoPlay muted loop src={'./assets/videos/banner-location.mp4'}></video>
      </div>
      <div>
        <h1>Soluciones de Localización</h1>
        <p className='stretch centered'>Optimiza tu logística y controla tus activos con nuestras avanzadas herramientas de geolocalización.</p>
      </div>
    </section>

    <section className="compressed bg-alt centered">
      <Slider content={
        <div>
          {
            sliderContent.map(c=>(
              <div key={c.name}>
                <h2>{c.name}</h2>
                <img loading="lazy" src={c.url} alt={c.name} aria-label={c.name} title={c.name}/>
              </div>
            ))
          }
        </div>
      } customClass="full" />
    </section>

    <section className="compressed dark">
      <h2 data-aos="fade-up">Potenciando la Precisión y la Eficiencia con Soluciones de Localización Avanzadas</h2>
      <p data-aos="fade-up" className='stretch'>En {Name}, entendemos que en un mundo interconectado, conocer la ubicación exacta de sus activos, personal y recursos es crucial para maximizar la eficiencia operativa y tomar decisiones informadas. Nuestros Servicios de Localización están diseñados para ofrecerle la precisión que necesita en tiempo real.</p>
      <div className="exposer inner">
        <div className="card-expo flow" data-aos="fade-right">
          <img loading="lazy" src={`${assetsLocation}activos.webp`} alt='Vehículo escoltado por drones' aria-label='Vehículo escoltado por drones' title='Vehículo escoltado por drones' />
          <div>
            <h3>Seguimiento de Activos</h3>
            <p>Localice y gestione sus activos de manera eficiente, minimizando pérdidas y optimizando el uso de recursos.</p>
          </div>
        </div>
        <div className="card-expo flow" data-aos="fade-left">
          <img loading="lazy" src={`${assetsLocation}geolocalizacion.webp`} alt='Vecindario con pines de localización en puntos de interés' aria-label='Vecindario con pines de localización en puntos de interés' title='Vecindario con pines de localización en puntos de interés' />
          <div>
            <h3>Geolocalización en Tiempo Real</h3>
            <p>Monitoree la ubicación de su personal y equipos en tiempo real para mejorar la seguridad y la eficiencia operativa.</p>
          </div>
        </div>
      </div>
      <div className="exposer inner" data-aos="fade-up">
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsLocation}geocercas.webp`} alt='Vecindario con una geocerca en hologramas' aria-label='Vecindario con una geocerca en hologramas' title='Vecindario con una geocerca en hologramas' />
          <div>
            <h3>Geocercas Inteligentes</h3>
            <p>Defina zonas virtuales para recibir alertas automáticas cuando un activo o persona entra o sale de un área específica.</p>
          </div>
        </div>
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsLocation}rutas.webp`} alt='Realidad aumentada dentro de cabina de vehículo' aria-label='Realidad aumentada dentro de cabina de vehículo' title='Realidad aumentada dentro de cabina de vehículo' />
          <div>
            <h3>Optimización de Rutas</h3>
            <p>Mejore la logística y distribución con rutas optimizadas basadas en datos precisos de localización.</p>
          </div>
        </div>
      </div>
    </section>

    <section className='compressed c2'>
      <div>
        <h2 data-aos="fade-down">Áreas de Aplicación</h2>
        <p data-aos="fade-down">Nuestros Servicios de Localización están diseñados para adaptarse a una variedad de industrias, incluyendo:</p>
        <ul data-aos="fade-up">
          <li><strong>Logística y Transporte: </strong>Optimice la entrega de productos y el seguimiento de flotas con datos de ubicación en tiempo real.</li>
          <li><strong>Agricultura: </strong>Monitoree maquinaria agrícola, ganado y otros activos en tiempo real para maximizar la productividad y reducir costos.</li>
          <li><strong>Construcción: </strong>Gestione la ubicación de equipos y personal en grandes proyectos para mejorar la eficiencia y la seguridad.</li>
          <li><strong>Salud: </strong>Mejore la atención al paciente y la seguridad mediante el seguimiento en tiempo real de personal y equipos médicos en hospitales y clínicas.</li>
        </ul>
        <button data-aos="fade-up"><a role='navigation' title='Ir al apartado de Contacto' href="#contacto"></a>Contáctanos</button>
      </div>
      <div shake='true' shake-floating='true' shake-shadow='true' shake-glow='true' id='card-location' shake-perspective='1600' shake-angle='30'>
        <img loading="lazy" src={`${assetsLocation}areas-aplicacion.webp`} alt='Cultivo de hortalizas' aria-label='Cultivo de hortalizas' title='Cultivo de hortalizas' />
        <div data-aos="fade-left" shake-depth='2' className="overlay cc2">
          <span shake-depth='3'>150+</span>
          <p shake-depth='4'>Clientes satisfechos</p>
          <span shake-depth='3'>15</span>
          <p shake-depth='4'>Años de experiencia</p>
        </div>
      </div>
    </section>

    {/* <section className="fw">
      <h2>Opiniones de nuestros clientes</h2>
      <Slider content={
        <div data-aos="fade-down">
          <div className='witness stars5'>
            <p>Gracias a la solución de HPE, hemos optimizado nuestros procesos de IA y mejorado la eficiencia operativa en poco tiempo.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Ana López</span>
              <p>Barcelona</p>
            </div>
          </div>
          <div className='witness stars4'>
            <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Carlos Ruiz</span>
              <p>Madrid</p>
            </div>
          </div>
          <div className='witness stars4'>
            <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Carlos Ruiz</span>
              <p>Madrid</p>
            </div>
          </div>
        </div>
      } customClass={'compressed'} />
    </section> */}
    <Form
      title={'Conéctese con Nosotros'}
      content={'Descubra cómo los Servicios de Localización de SANOLIVAR pueden transformar la manera en que gestiona sus activos y recursos. Contáctenos hoy para obtener más información y comenzar a optimizar sus operaciones con soluciones de localización avanzadas.'}
      img={{ src: `${assetsLocation}contacto.webp`, alt: 'Brújula sobre mapa' }}
      form={[
        {
          label: 'Nombre contacto',
          type: 'text',
          id: 'nombre',
          placeholder: 'Ingrese su nombre aquí'
        },
        {
          label: 'Correo electrónico',
          type: 'email',
          id: 'email',
          placeholder: 'Ingrese su correo aquí'
        },
        {
          label: 'Mensaje',
          type: 'textarea',
          id: 'mensaje',
          placeholder: 'Déjanos un mensaje aquí'
        },
        {
          label: 'Enviar Mensaje',
          type: 'submit',
          id: 'submit',
        }
      ]}
      redirect={`${root}servicios-locationservices.html`}
    />
    <Footer />
    <Chatbot />
  </StrictMode>
)
